export default __webpack_public_path__ + "static/media/V2.1ff4f8e1.png";